export default {
    // table options
    TABLE_OPTIONS: {
        buddycomAccount: { value: 1 },
        ipRadioAccount: { value: 2 },
        group: { value: 3 },
    },
    // object type
    OBJECT_NODE: 0,
    OBJECT_USER: 1,
    OBJECT_TALKGROUP: 2,
    OBJECT_ASSISTANT: 3,
    OBJECT_CUSTOM_ASSISTANT: 4,
    OBJECT_BUDDYCOM_CALL_USER: 5,
    OBJECT_IP_RADIO: 6,

    // root node id
    ROOT_NODE_ID: 1,

    // error code
    CONFIRM_NODE: 0,
    CONFIRM_USER: 1,
    CONFIRM_GROUP: 2,
    CONFIRM_ACL_READ: 3,
    CONFIRM_ACL_WRITE: 4,
    CONFIRM_GROUP_OF_USER: 5,
    CONFIRM_USER_OF_GROUP: 6,
    CONFIRM_TENANT: 7,
    CONFIRM_CLIENT_SETTING: 8,
    CONFIRM_RESTRICT_LOGOUT: 9,
    CONFIRM_RESTRICT_PEERTALK: 10,
    CONFIRM_PARTNER_USER: 11,
    CONFIRM_PARTNER: 12,
    // purchase license request
    PURCHASE_REQUEST_NEW: 1,
    PURCHASE_REQUEST_MODIFY: 2,
    PURCHASE_REQUEST_AUTO_UPDATE: 3,
    PURCHASE_REQUEST_PENDING_CHECK: 4,
    PURCHASE_REQUEST_NEW_PLAN: 5,
    PURCHASE_REQUEST_MODIFY_PLAN: 6,
    PURCHASE_REQUEST_CHANGE_PLAN: 7,
    // billing type
    BILLING_UNDEFINED: 0,
    BILLING_CREDIT_CARD: 1,
    BILLING_PAPER: 2,
    BILLING_PAID: 3,
    BILLING_TRANSFER: 4,
    // order id prefix
    ORDER_ID_PREFIX_PAID: "P",
    ORDER_ID_PREFIX_NEW_PAID: "NP",
    ORDER_ID_PREFIX_CONTINUE_PAID: "CP",
    ORDER_ID_PREFIX_UPDATE_PAID: "UP",
    ORDER_ID_PREFIX_NEW_PAID_TEST: "NT",
    ORDER_ID_PREFIX_CONTINUE_PAID_TEST: "CT",
    ORDER_ID_PREFIX_UPDATE_PAID_TEST: "UT",
    // paid member status
    PAID_STATUS_NOT_FOUND: 0,
    PAID_STATUS_REVIEWING: 1,
    PAID_STATUS_ENABLE_IN_USE: 2,
    PAID_STATUS_ENABLE_NOT_IN_USE: 3,
    PAID_STATUS_DISABLE: 4,
    // credit payment upper limit
    CREDIT_UPPER_LIMIT_MONTH: 300000,
    CREDIT_UPPER_LIMIT_YEAR: 9250000,
    // license
    LICENSE_USER: 1,
    LICENSE_SPEECH_TEXT: 2,
    LICENSE_TRANSLATION: 3,
    LICENSE_CONFIG: 4,
    LICENSE_ACCESS_LOG: 5,
    LICENSE_TRACKING: 6,
    LICENSE_MAP_TALK: 7,
    LICENSE_HISTORY_RETENTION: 8,
    LICENSE_HISTORY_RETENTION_ADVANCED: 9,
    LICENSE_HISTORY_RETENTION_TRACKING: 10,
    LICENSE_VIDEO: 11,
    LICENSE_SAML: 12,
    OFF_PLAN_LICENSE_BELL: 50,
    OFF_PLAN_LICENSE_DEDICATED: 51,
    OFF_PLAN_LICENSE_CALL_CENTER: 52,
    OFF_PLAN_LICENSE_BUDDY_BOT_API: 53,
    OFF_PLAN_LICENSE_MAP_IMAGE_OVERLAY: 54,
    OFF_PLAN_LICENSE_CALL: 55,
    OFF_PLAN_LICENSE_SAFETY_SUPPORT: 56,
    RECURRING_SPEECH_TEXT: 100,
    RECURRING_TRANSLATION: 101,
    RECURRING_DATA_TRANSFER: 102,
    CHARGE_SPEECH_TEXT: 200,
    CHARGE_TRANSLATION: 201,
    CHARGE_DATA_TRANSFER: 202,
    PURCHASE_UNIT_SPEECH_TEXT:  1800,
    PURCHASE_UNIT_TRANSLATE:  9000,
    PURCHASE_UNIT_DATA_TRANSFER: 1073741824, // 1024^3
    RECURRING_MAX_SPEECH_TEXT: 1800000000000,
    RECURRING_MAX_TRANSLATION: 9000000000000,
    RECURRING_MAX_LIVE_CAST: 100000,
    // user option
    USER_OPTION_SPEECH_TEXT: 0,
    USER_OPTION_TRANSLATION: 1,
    USER_OPTION_VIDEO: 2,
    USER_OPTION_TRACKING: 3,
    USER_OPTION_MAP_TALK: 4,

    // talkgroup option shift
    TALKGROUP_OPTION_INTERRUPT: 0,
    TALKGROUP_OPTION_MULTI_TALK: 1,
    TALKGROUP_OPTION_SPEECH_TEXT: 3,
    TALKGROUP_OPTION_TRANSLATION: 4,
    TALKGROUP_OPTION_VIDEO: 5,
    TALKGROUP_OPTION_LOCATION: 6,
    TALKGROUP_OPTION_TRACKING: 7,
    TALKGROUP_OPTION_MAP_TALK: 8,
    TALKGROUP_OPTION_MANDATORY: 9,
    TALKGROUP_OPTION_FLAG_LONG_TALKGROUP: 15,

    // trial option
    TRIAL_OPTION_SPEECH_TEXT: 1,
    TRIAL_OPTION_TRANSLATION: 2,
    TRIAL_OPTION_VIDEO: 4,
    TRIAL_OPTION_CONFIG: 8,
    TRIAL_OPTION_ACCESS_LOG: 16,
    TRIAL_OPTION_TRACKING: 32,
    TRIAL_OPTION_MAP_TALK: 64,
    TRIAL_OPTION_SAML: 128,
    TRIAL_OPTION_BELL: 256,
    TRIAL_OPTION_CALL_CENTER: 512,
    TRIAL_OPTION_BUDDY_BOT_API: 1024,
    TRIAL_OPTION_MAP_IMAGE_OVERLAY: 2048,
    TRIAL_OPTION_BUDDYCOM_CALL: 4096,
    TRIAL_OPTION_SAFETY_SUPPORT: 8192,
    // purchase period type
    PURCHASE_PERIOD_MONTHLY:  0,
    PURCHASE_PERIOD_YEARLY:  1,
    PURCHASE_PERIOD_TRIAL:  99,
    // plan type
    LICENSE_PLAN_SEPARATE: 0,
    LICENSE_PLAN_LITE: 1000,
    LICENSE_PLAN_STANDARD: 1001,
    LICENSE_PLAN_ENTERPRISE: 1002,
    LICENSE_PLAN_TALK_LITE: 1003,
    LICENSE_PLAN_TALK_ENT: 1004,
    LICENSE_PLAN_LIVE_LITE: 1005,
    LICENSE_PLAN_LIVE_ENT: 1006,
    PLAN_UPGRADE_TL_TE: 1100,
    PLAN_UPGRADE_TL_LL: 1101,
    PLAN_UPGRADE_TL_LE: 1102,
    PLAN_UPGRADE_TE_LE: 1103,
    PLAN_UPGRADE_LL_LE: 1104,
    // currency
    CURRENCY_DOLLER: 1,
    CURRENCY_YEN: 2,
    // grace unit
    GRACE_UNIT_DAY: 0,
    GRACE_UNIT_MONTH: 1,
    // tenant connect status
    TENANT_CONNECT_WANT: 0,
    TENANT_CONNECT_ALLOW: 1,
    TENANT_CONNECT_ESTABLISH: 2,
    TENANT_CONNECT_IMPORT_FORCE_UNLINK: 3,
    TENANT_CONNECT_EXPORT_FORCE_UNLINK: 4,
    // tenant state
    CONTRACT_ACTIVE:  1,
    CONTRACT_NOUPDATE:  2,
    CONTRACT_TERMINATE:  3,
    CONTRACT_ACTIVATING:  4,
    CONTRACT_TRIAL: 5,
    CONTRACT_TRIAL_END: 6,
    CONTRACT_DEVELOPMENT: 7,
    CONTRACT_DISABLED: 8,
    CONTRACT_PAID_REVIEW: 9,
    CONTRACT_APPLESS: 10,
    // deferred_request
    DEFERRED_MONTH_TO_YEAR: 1,
    DEFERRED_YEAR_TO_MONTH: 2,
    DEFERRED_TRIAL_TO_ACTIVE_MONTH: 3,
    DEFERRED_TRIAL_TO_ACTIVE_YEAR: 4,
    DEFERRED_TRIAL_TO_NOUPDATE_MONTH: 5,
    DEFERRED_TRIAL_TO_NOUPDATE_YEAR: 6,
    DEFERRED_CHANGE_PRICE: 7,
    DEFERRED_DOWNGRADE_TE_TO_TL: 8,
    DEFERRED_DOWNGRADE_TE_TO_LL: 9,
    DEFERRED_DOWNGRADE_LL_TO_TL: 10,
    DEFERRED_DOWNGRADE_LL_TO_TE: 11,
    DEFERRED_DOWNGRADE_LE_TO_LL: 12,
    DEFERRED_DOWNGRADE_LE_TO_TE: 13,
    DEFERRED_DOWNGRADE_LE_TO_TL: 14,
    DEFERRED_UPGRADE_TL_TO_TE: 15,
    DEFERRED_UPGRADE_TL_TO_LL: 16,
    DEFERRED_UPGRADE_TL_TO_LE: 17,
    DEFERRED_UPGRADE_TE_TO_LE: 18,
    DEFERRED_UPGRADE_LL_TO_LE: 19,
    DEFERRED_CHANGE_PURCHASE_TERM: 50,

    // error code
    STATUS_SUCCESS: 0,
    STATUS_SUCCESS_WITH_ERRORINFO: 1,
    STATUS_BUSY: 2,
    STATUS_PENDING: 3,
    STATUS_NEED_MORE_PROCESSING: 7,
    STATUS_PARTIAL_SUCCESS: 10,
    STATUS_ERROR_UNKNOWN: -1,
    STATUS_ERROR_INVALID_PARAMETER: -2,
    STATUS_ERROR_DENIED: -3,
    STATUS_ERROR_ALREADY_EXISTED: -4,
    STATUS_ERROR_NOT_FOUND: -5,
    STATUS_ERROR_BATCH_PROCESS: -6,
    STATUS_ERROR_TOO_MANY_ENTRY: -7,
    STATUS_ERROR_DUPLICATED_TENANT: -8,
    STATUS_ERROR_OBJECT_NOT_FOUND: -10,
    STATUS_ERROR_PARENT_NOT_FOUND: -11,
    STATUS_ERROR_INVALID_OBJECT_FORMAT: -12,
    STATUS_ERROR_INVALID_PASSWORD_FORMAT: -13,
    STATUS_ERROR_INVALID_USER_OPTION: -14,
    STATUS_ERROR_LICENSE_INSUFFICIENT: -15,
    STATUS_ERROR_OPTION_LICENSE_INSUFFICIENT: -16,
    STATUS_ERROR_INVALID_DISPLAYNAME: -17,
    STATUS_ERROR_USER_NOT_FOUND: -18,
    STATUS_ERROR_TALKGROUP_NOT_FOUND: -19,
    STATUS_ERROR_CLOSING_RUNNING: -20,
    STATUS_ERROR_TIMEOUT: -21,
    STATUS_ERROR_EXTERNAL_SYSTEM: -22,
    STATUS_ERROR_PERMISSION_DENIED: -23,
    STATUS_ERROR_OPTION_UNMATCH: -24,
    STATUS_ERROR_USER_EXISTS: -25,
    STATUS_ERROR_ABORT: -26,
    STATUS_ERROR_EXCEEDS_MAX_SIZE: -27,
    STATUS_ERROR_INVALID_ORGANIZATION: -28,
    STATUS_ERROR_INVALID_TITLE: -29,
    STATUS_ERROR_INVALID_DURATION_LIMIT: -30,
    STATUS_ERROR_EXCEEDS_MAX_COUNT: -31,
    STATUS_ERROR_EXCEEDS_MANDATORY_LIMIT: -32,
    STATUS_ERROR_EXCEEDS_CONNECTED_TALKGROUP_LIMIT: -50,
    STATUS_ERROR_AUTH_FAILED: -33,
    STATUS_ERROR_INVALID_PHONE_NUMBER: -34,
    STATUS_ERROR_INVALID_SAVE_TALKRECORD: -35,
    STATUS_ERROR_INVALID_CSV_TEMPLATE: -36,
    STATUS_ERROR_USER_HAS_EXPORTED: -37,
    STATUS_ERROR_INVALID_UTF8: -38,
    STATUS_ERROR_INVALID_CSV_FORMAT: -39,
    STATUS_ERROR_STILL_ASSIGNED: -40,
    STATUS_ERROR_INVALID_TWO_PHASE_METHOD: -41,
    STATUS_ERROR_INVALID_SUBGROUP_ID: -42,
    STATUS_ERROR_UNDELETABLE_OBJECT: -43,
    STATUS_ERROR_INVALID_EMAIL: -44,
    STATUS_ERROR_INVALID_SAVE_LIVECAST: -45,
    STATUS_ERROR_MULTI_AND_INTERRUPT_SIMULTANEOUSLY: -46,
    STATUS_ERROR_NOT_ASSIGNED: -47,
    STATUS_ERROR_STORAGE: -48,
    STATUS_ERROR_TOO_MANY_REQUEST: -49,
    STATUS_ERROR_BELL_ASSIGNED: -52,
    STATUS_ERROR_TOO_MANY_DELETE_USERS: -53,
    STATUS_ERROR_ALREADY_CHANGE_STATUS: -54,
    STATUS_ERROR_TENANT_ALREADY_DELETED_OR_TERMINATED: -55,
    STATUS_ERROR_TENANT_ALREADY_DELETED: -56,
    STATUS_ERROR_UNAVAILABLE_TIME: -57,
    STATUS_ERROR_UNAVAILABLE_POINT: -58,
    STATUS_ERROR_NO_CONTENTS: -59,
    STATUS_ERROR_NO_MORE_FREE_SLOT: -60,
    STATUS_ERROR_BELL_AUTH_USER_LIMIT: -61,
    STATUS_ERROR_BELL_CSV_INVALID_TIMEZONE_HEADER: -62,
    STATUS_ERROR_EXCEEDS_MAX_COUNT_ONCE: -65,
    STATUS_ERROR_NOT_EDITABLE: -71,
    STATUS_ERROR_EASYLOGIN_TALKGROUP_NOT_FOUND: -72,
    STATUS_ERROR_DUPLICATED: -73,
    STATUS_ERROR_UPDATED_BEHIND: -74,
    STATUS_ERROR_LICENSE_REDUCE_TOO_SMALL: -76,
    STATUS_ERROR_LICENSE_BELOW_DEPENDENT: -77,
    STATUS_ERROR_MAP_IMAGE_OVERLAY_NOT_EMPTY: -78,
    STATUS_ERROR_EXCEEDS_STORAGE_CAPACITY: -79,
    STATUS_ERROR_EXCEEDS_MAX_MAP_IMAGE_OVERLAY_PER_GROUP: -80,
    STATUS_ERROR_EXCEEDS_MAX_GROUPS_PER_MAP_IMAGE_OVERLAY: -81,
    STATUS_ERROR_BUDDYCOM_CALL_ASSIGNED: -82,
    STATUS_ERROR_OPTION_LICENSE_INSUFFICIENT_LINKED_TENANT: -83,
    STATUS_ERROR_ALREADY_LOCKED: -84,
    STATUS_ERROR_INVALID_VIDEO_DURATION_LIMIT: -85,
    // 無線機管理一般ユーザー用エラーコード -90 to -95
    STATUS_ERROR_GENERAL_ADMIN_NO_RIGHTS_PERMISSION: -90,
    STATUS_ERROR_GENERAL_ADMIN_TRACKING_PERMISSION_WITH_OTHER: -91,
    STATUS_ERROR_GENERAL_ADMIN_RADIO_SETTING_ALL_PERMISSION_WITH_OTHERS: -92,
    STATUS_ERROR_GENERAL_ADMIN_ROOT_NODE_PERMISSION_REMAINING: -93,
    STATUS_ERROR_RADIO_MANAGER_IS_C2C_ADMIN: -94,

    //Setting.vueの同名の定数と対応。Setting.vueの外部で値を参照する必要があるときに定義。
    SETTING_INTER_COMPANY_IMPORT: 4,
    SETTING_INTER_COMPANY_EXPORT: 5,
    SETTING_STT_EXTENSION_ROOT: 11,
    SETTING_P2P_ROOT: 104,

    // On-Off mode
    STATUS_MODE_OFF: 0,
    STATUS_MODE_ON: 1,
    // option_flag from tenant
    TALK_RECORD_DELETE: 1,
    RESTRICT_MAX_TALKGROUP: 2,
    ENABLE_PERMIT_IP: 4,
    AI_APP_COOPERATION_TRIAL: 8,
    TWO_PHASE_METHOD: 16,
    SMS_TWO_PHASE_METHOD: 32,
    DEVICE_TOKEN: 64,
    ENABLE_MAIL_NOTIFICATION: 128,
    ENABLE_SUBGROUP: 256,
    ENABLE_E2E_ENCRYPTION: 512,
    LARGE_TALKGROUP_LIST: 1024,
    CSV_NO_LIMIT: 2048,
    MERGE_VIDEO_WITH_AUDIO: 4096,
    DEVICE_MANAGEMENT: 8192,
    DISCONNECT_ALERT_GROUP: 16384,
    LONG_LIVECAST: 32768,

    // tenant apps settings
    PINNED_RECORD: 1,
    TRANSLATION: 2,
    CHAT_GPT: 4,
    AOAI: 8,
    MAP_IMAGE_OVERLAY: 16,
    RESERVE_TALK: 64,
    RESERVED1: 4194304,
    RESERVED2: 8388608,
    RESERVED3: 16777216,

    // tenant restricted item type
    RESTRICTED_ITEM_TYPE_APPS: 1,

    // partner administrator rights.
    PARTNER_ADMIN_NORMAL: 0,
    PARTNER_ADMIN_ALL: 1,
    PARTNER_ADMIN_WRITE: 2,
    PARTNER_ADMIN_OPERATION: 4,
    // user notification mail.
    NOTIFICATION_MAIL_CONTRACT: 1,
    NOTIFICATION_MAIL_MAINTENANCE: 2,
    NOTIFICATION_MAIL_SERVICE_FAILURE: 4,
    NOTIFICATION_MAIL_AUTO_NOTICE: 8,
    // user type for tenant_mail_destination
    DESTINATION_TYPE_END_USER: 0,
    DESTINATION_TYPE_PARTNER: 1,
    // description of link tenant type
    LINK_DESCRIPTION_WANT: "使用できるテナント",
    LINK_DESCRIPTION_ALLOW: "使用を許可するテナント",
    // privilege name
    PRIVILEGE_TENANT_ADMIN: "tenantadmin",
    PRIVILEGE_RADIO_MANAGE: "radiomanage",
    PRIVILEGE_ALERT: "alert",
    PRIVILEGE_FORCE_STOP_VOICE_REPORT: "forcestopvoicereport",
    // restriction name
    RESTRICTION_LOGIN: "login",
    RESTRICTION_LOGOUT: "logout",
    RESTRICTION_PEER_TO_PEER: "peertopeer",
    RESTRICTION_MAP: "map", // abolished (replaced by 'maptab')
    RESTRICTION_MAP_TAB: "maptab",
    RESTRICTION_CHAT: "chat", // abolished (replaced by 'sendchat')
    RESTRICTION_CHAT_TAB: "chattab",
    RESTRICTION_CHAT_SEND: "sendchat",
    RESTRICTION_SAVE_CONTENTS: "save",
    RESTRICTION_MODIFY_NAME: "modifyname",
    // user object flag
    UNDELETABLE: 1,
    TRANSITION: 2,
    ADMIN_ONLY: 4,
    // user information name
    USER_PUBLISH_INFORMATION_ACCURACY: "accuracy",
    USER_PUBLISH_INFORMATION_SPEED: "speed",
    USER_PUBLISH_INFORMATION_DIRECTION: "direction",
    USER_PUBLISH_INFORMATION_BATTERY: "battery",
    // user selection dialog type
    USER_SELECTION_ACL_RO: 0,
    USER_SELECTION_ACL_RW: 1,
    USER_SELECTION_ACL_LINK: 2,
    USER_SELECTION_GROUP_OF_USER: 3,
    USER_SELECTION_TENANT_ADMIN: 4,
    USER_SELECTION_FORCE_ACTIVATE: 5,
    USER_SELECTION_FORCE_RESTRICTIONS: 6,
    USER_SELECTION_USER_PUBLISH_INFORMATION: 7,
    USER_SELECTION_BELL_AUTH: 8,
    USER_SELECTION_DICTIONARY_AUTH: 9,
    USER_SELECTION_FORCE_STOP_VOICE_REPORT: 10,
    USER_SELECTION_RADIO_MANAGE: 11,
    // smartphone's menu item
    MENU_CREATE_NEW: "createNew",
    MENU_DASHBOARD: "dashBoard",
    MENU_USER: "user",
    MENU_GROUP: "group",
    MENU_LICENSE: "license",
    MENU_RIGHTS: "rights",
    MENU_ACCOUNT: "account",
    MENU_LOGOUT: "logout",
    // csv import type
    CSV_USER: "user",
    CSV_GROUP: "talkgroup",
    CSV_USER_GROUP: "usertalkgroup",
    CSV_IPRADIO: "ipradio",
    CSV_BELL: "bell",
    CSV_BELL_AUTH_USER: "bellauthuser",
    CSV_ERROR_INFO: "errorInfo",
    // icon image store path
    ICON_IMAGE_PATH: "https://aldio-public.s3-ap-northeast-1.amazonaws.com/map_icon/",
    // csv template file version
    CSV_USER_TEMPLATE_VERSION: "4.0",
    CSV_GROUP_TEMPLATE_VERSION: "2.0",
    CSV_USERGROUP_TEMPLATE_VERSION: "1.0",
    CSV_IPRADIO_TEMPLATE_VERSION: "1.0",
    CSV_BELL_TEMPLATE_VERSION: "1.0",
    CSV_BELL_AUTH_USER_TEMPLATE_VERSION: "1.0",

    // talk record type
    TALK_RECORD_VOICE: 0,
    TALK_RECORD_TEXT: 1,
    TALK_RECORD_BINARY: 2,
    TALK_RECORD_ONLOAD_DATA: 3,

    // talk record attributes
    TALK_RECORD_ATTRIBUTE_NONE: 0,
    TALK_RECORD_ATTRIBUTE_VOICE_REPORT: 1 << 0,
    TALK_RECORD_ATTRIBUTE_MAP: 1 << 1,

    // offload data
    // TODO: keep being synchronized to Comm server
    OFFLOAD_DATA_VIDEO: new Set(['MP4', 'MOV']),
    OFFLOAD_DATA_IMAGE: new Set(['PNG', 'JPG']),
    // tenant search condition
    SEARCH_CONDITION_COMPANY_ALL: 1,
    SEARCH_CONDITION_COMPANY_PARTIAL: 2,
    SEARCH_CONDITION_TENANT_ALL: 3,
    SEARCH_CONDITION_TENANT_PARTIAL: 4,
    SEARCH_CONDITION_SURVEY_ID: 5,
    SEARCH_CONDITION_TENANT_ID: 6,
    // sub group info type
    SUB_GROUP_INFO_DESTINATIONS: 1,
    SUB_GROUP_INFO_USERS: 2,
    // notification mail type
    MAIL_TYPE_TERM_OF_SERVICE: 3,
    MAIL_TYPE_MAINTENANCE: 4,
    MAIL_TYPE_APP_UPDATE: 5,
    MAIL_TYPE_SERVICE_FAILURE: 6,
    MAIL_TYPE_OTHER: 7,
    // notification mail type which customer and partner will receive.
    RECEIVE_CONTRACT_NOTIFICATION: 1,
    RECEIVE_SYSTEM_NOTIFICATION: 2,
    RECEIVE_SERVICE_FAILURE: 4,
    RECEIVE_AUTO_NOTICE: 8,
    // key_vault
    VAULT_SERVICE_STORAGE: 1,
    VAULT_SERVICE_CLIENT: 2,
    VAULT_SERVICE_SNS: 3,
    VAULT_SERVICE_AI: 4,
    VAULT_PROVIDER_NAME_BOX: 'box',
    VAULT_PROVIDER_NAME_DROPBOX: 'dropbox',
    VAULT_PROVIDER_NAME_GOOGLE: 'google',
    VAULT_PROVIDER_NAME_MICROSOFT: 'microsoft',
    VAULT_PROVIDER_NAME_SCANDIT: 'scandit',
    VAULT_PROVIDER_NAME_WORKS_MOBILE: 'works_mobile',
    VAULT_PROVIDER_NAME_WORKS_MOBILE_V2: 'works_mobile_v2',
    VAULT_PROVIDER_NAME_AOAI: 'aoai',
    VAULT_TOKEN_TYPE_REFRESH: 1,
    VAULT_TOKEN_TYPE_ACCESS: 2,
    VAULT_TARGET_TYPE_GENERAL: 0,
    VAULT_TARGET_TYPE_IOS: 1,
    VAULT_TARGET_TYPE_ANDROID: 2,
    // fixed_phrase_category_value
    FIXED_PHRASE_CATEGORY_TEXT: 1,
    FIXED_PHRASE_CATEGORY_SOUND: 2,
    FIXED_PHRASE_CATEGORY_MELODY: 3,
    FIXED_PHRASE_CATEGORY_RESET: 4,
    // easy login type
    EASY_LOGIN_TYPE_RANDOM: 1,
    EASY_LOGIN_TYPE_SELECTION: 2,
    // Engine for P2P
    DEFAULT_STT_ENGINE_CLASS_NAME: "stt.Google.GoogleSTT",
    DEFAULT_TRANSLATE_ENGINE_CLASS_NAME: "translate.Google.GoogleTranslate",
    // Bluetooth alert type option
    BLUETOOTH_ALERT_SOUND: 1,
    BLUETOOTH_ALERT_VIB: 2,
    // Merge video with audio
    VIDEO_WITH_AUDIO_SUFFIX_ORIGINAL: ":ORIGINAL.mp4",
    VIDEO_WITH_AUDIO_SUFFIX_COMPLETED: ":WITHAUDIO.mp4",
    VIDEO_WITH_AUDIO_SUFFIX_FAILED: ":ERROR.mp4",
    // Device Auth
    DEVICE_MANAGEMENT_STATUS_UNAPPROVED: 0,
    DEVICE_MANAGEMENT_STATUS_APPROVED: 1,
    DEVICE_MANAGEMENT_PAGINATION_SIZE: 50,

    //limit
    LIMIT_EDIT_TAGS: 100,
    LIMIT_MAIL_ADDRESS: 10,

    //AOAI
    MAX_CHATBOT_COUNT: 10,

    // Buddycom Bell
    BELL_MAX_LICENSE_NUM: 10000,
    BELL_MAX_NAME_LENGTH: 50,
    BELL_MAX_DISPLAY_NAME_LENGTH: 50,
    BELL_MAX_TARGET_GROUP_LIMIT: 1,
    BELL_MAX_AUTH_USER_LIMIT: 5,
    BELL_MAX_AUTHED_BELL_LIMIT: 500,
    BELL_PAGINATION_SIZE: 100,

    // Buddycom Bell Display Setting
    BELL_MAX_PAGE_SIZE: 3,
    BELL_MAX_SELECTION_SIZE: 5,
    BELL_MAX_TITLE_LENGTH: 40,
    BELL_MAX_MESSAGE_LENGTH: 100,
    BELL_MAX_SELECTION_LENGTH: 40,
    // for half width language
    BELL_MAX_TITLE_LENGTH2: 70,
    BELL_MAX_MESSAGE_LENGTH2: 150,
    BELL_MAX_SELECTION_LENGTH2: 70,

    // Call
    BUDDYCOM_CALL_MAX_LICENSE_NUM: 10000,

    // dedicated server
    FIRST_DEDICATED_SERVER_ID: 10000,

    //two phase login from console
    LOGIN_METHOD_NO_SETTING: 0,
    LOGIN_METHOD_MAIL: 1,
    LOGIN_METHOD_GA: 2,

    CONFIRM_PURPOSE_TWO_PHASE_AUTH: 1,
    CONFIRM_PURPOSE_INIT_PASSWORD: 2,

    // batch
    // csv
    BATCH_CSV_NO_QUEUE: 'batch_csv_no_queue',
    BATCH_CSV_IN_QUEUE: 'batch_csv_in_queue',
    BATCH_CSV_PROCESSING: 'batch_csv_processing',

    // stt dictionary
    STT_DICTIONARY_MAX_AUTH_USER_LIMIT: 10,

    // client settings
    CLIENT_SETTINGS_MAX: 1000,

    // client settings sub button mode
    SUB_BUTTON_NONE : 0,
    SUB_BUTTON_NFC : 1,
    SUB_BUTTON_CUSTOMURL : 2,
    SUB_BUTTON_VOX : 3,
    SUB_BUTTON_FTT : 4,
    SUB_BUTTON_Secondary : 5,
    SUB_BUTTON_LOCK : 6,
    SUB_BUTTON_METADATA : 7,
    SUB_BUTTON_FixedPhrase : 8,
    SUB_BUTTON_DirectTalk : 9,
    SUB_BUTTON_Assistant : 10,
    SUB_BUTTON_Custom_Assistant : 11,
    SUB_BUTTON_Speech_Restriction : 12,
    SUB_BUTTON_Voice_Report : 13,
    SUB_BUTTON_Reserve_Talk : 14,

    // assistant category
    ASSISTANT_CATEGORY_BUILT_IN: 0,
    ASSISTANT_CATEGORY_CUSTOM: 1,

    // built in assistant
    ASSISTANT_BUILT_IN_VOICE_COMMAND: 0,
    ASSISTANT_BUILT_IN_ECHO: 1,
    ASSISTANT_BUILT_IN_CHATGPT: 2,

    // custom assistant
    ASSISTANT_CUSTOM_THIRD_AI: 0,
    ASSISTANT_CUSTOM_BUDDY_BOT: 1,
    ASSISTANT_CUSTOM_RAG_BETA1: 2,

    // link category
    LINK_CATEGORY: {
        IMPORT: 1,
        EXPORT: 2,
    },

    C2C_OPTION: {
        SKIP_ACL_CHECK: 1,
        ALLOW_CALL: 1 << 1,
        VIEW_GROUP_TALK_RECORD: 1 << 2,
        ALLOW_IMPORT_TENANT_TO_VIEW_USER_TRACKING: 1 << 3,
    },

    C2C_PERMISSION_TYPE: {
        USER_SELECTION: 1,
        TALK: 2,
        TRACKING: 3,
    },

    MAX_C2C_CONNECTIONS: 1000,

    // User & Group
    TABLE_DISPLAY_NUMBER_BY_PAGE: 250,

    GRANT_LEVEL_PERMISSION: {
        NONE: 0,
        VIEW: 1,
        EDIT: 2,
    },

    RADIO_INTEGRATE_PERMISSIONS_CONSOLE: {
        EDIT_USER_AND_GROUP_DEFINITION: "edit_user_and_group_definition",
        EDIT_USER_TALKGROUP_ASSIGNMENT: "edit_user_talkgroup_assignment",
        TRACKING: "tracking",
    },

    RADIO_INTEGRATE_PERMISSIONS_RADIO: {
        EDIT_RADIO_SETTING_DEFINITION: "edit_radio_setting_definition",
        EDIT_RADIO_SETTING_ASSIGNMENT: "edit_radio_setting_assignment",
        EDIT_RADIO_SETTING_WIFI_ITEMS_DEFINITION: "edit_radio_setting_wifi_items_definition",
        EDIT_RADIO_USER_DISPLAY_ITEMS_DEFINITION: "edit_radio_user_display_items_definition",
    },

    RADIO_MODEL_P51: "KBX-P51/KBX-P51SA",

    REALTIME_USER_STATUS_TYPE: {
        NONE: 0,
        IS_CALLING: 1,
        EMERGENCY_LONE_WORKER: 2,
        EMERGENCY_MAN_DOWN: 3,
        EMERGENCY_STATIONARY_DETECTION: 4,
        EMERGENCY_MOTION_DETECTION: 5,
        EMERGENCY_ON_SELF: 6,
        IS_STUN: 99
    },

    CUT_VOICE_DELAY_QUEUE_SECONDS_DISABLED: 0,
    CUT_VOICE_DELAY_QUEUE_SECONDS_MIN: 1,
    CUT_VOICE_DELAY_QUEUE_SECONDS_MAX: 30,

    RESERVE_TALK_PLAYBACK_WAIT_MIN: 1,
    RESERVE_TALK_PLAYBACK_WAIT_MAX: 10,
};
